import { createElement, Fragment } from 'react';
import { func, object } from 'prop-types';
import { withTheme } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { c as _extends } from '../chunk-ad6ad343.js';
import { Container } from 'reakit';
import Media from 'react-media';
var initialState = {
  isSidebarOpen: true,
  isCollapsed: false,
  isMinimized: false
};
var actions = {
  openSidebar: function openSidebar() {
    return function () {
      return {
        isSidebarOpen: true
      };
    };
  },
  closeSidebar: function closeSidebar() {
    return function () {
      return {
        isSidebarOpen: false
      };
    };
  },
  maximizeSidebar: function maximizeSidebar() {
    return function () {
      return {
        isMinimized: false
      };
    };
  },
  minimizeSidebar: function minimizeSidebar() {
    return function () {
      return {
        isMinimized: true
      };
    };
  },
  handleChangeCollapsed: function handleChangeCollapsed(isCollapsed) {
    return function (state) {
      return {
        isCollapsed: isCollapsed,
        isMinimized: isCollapsed ? false : state.isMinimized,
        isSidebarOpen: !isCollapsed
      };
    };
  }
};

var PageContainer = function PageContainer(_ref) {
  var children = _ref.children,
      theme = _ref.theme;

  var breakpoint = _get(theme, 'fannypack.Page.collapseBreakpoint');

  var breakpointPx = _get(theme, "fannypack.layout." + breakpoint + "Breakpoint");

  return createElement(Container, {
    context: "page",
    initialState: initialState,
    actions: actions
  }, function (page) {
    return createElement(Fragment, null, createElement(Media, {
      query: "(max-width: " + breakpointPx + "px)",
      onChange: page.handleChangeCollapsed
    }), children(page));
  });
};

PageContainer.propTypes = {
  children: func.isRequired,
  theme: object
};
PageContainer.defaultProps = {
  theme: {}
};

var _PageContainer = withTheme(PageContainer);

var withPage = function withPage(C) {
  return function (props) {
    return createElement(_PageContainer, null, function (page) {
      return createElement(C, _extends({
        page: page
      }, props));
    });
  };
};

export default _PageContainer;
export { PageContainer, withPage };